@if (!isInArchiveMode) {
  <div class="object-actions mt-3">
    @if (isInEditMode) {
      @if (orderDetails !== null) {
        <button (click)="addDiscountCode()" class="btn btn-primary border btn-small">
          <i class="far fa-plus-square"></i>{{ 'SALES-ENTITY-MODIFICATION.OVERVIEW.BUTTON.ADD-DISCOUNT' | translate }}
        </button>
      }
      @if (orderDetails !== null) {
        <button (click)="openBulkCreditDialog()" class="btn btn-danger border btn-small">
          <i class="fas fa-ban"></i>{{ 'SALES.ORDERS.DETAILS.BTN.BULK-CREDIT' | translate }}
        </button>
      }
    }
    @if (!isInEditMode) {
      @if (showButton[getButtons().Renew]) {
        <span>
          <button (click)="renew.emit()" [disabled]="isLroRunning" class="btn btn-primary border btn-sm px-2 py-1" type="button">
            <i class="fas fa-redo"></i>{{'SALES.ORDERS.DETAILS.BTN.RENEW' | translate | uppercase}}
          </button>
          <span class="separator"></span>
        </span>
      }
      <button (click)="payOrder()" [disabled]="isLroRunning"
        class="btn btn-primary border btn-sm px-2 py-1" type="button">
        <i class="fas fa-credit-card"></i>
        {{'GENERIC.BUTTON.PAY' | translate | uppercase}}
      </button>
      @if (showButton[getButtons().SendPaymentRequest]) {
        <button (click)="initiatePayPerEmail()"
          [disabled]="isLroRunning || orderDetails.PayPerMailAllowed == false" class="btn btn-primary border btn-sm px-2 py-1" type="button">
          <i class="far fa-credit-card"></i>{{'SALES.ORDERS.DETAILS.BTN.SEND-PAYMENT-REQUEST' | translate | uppercase}}</button>
        }
        <span class="separator"></span>
        @if (showButton[getButtons().PrintOrderConfirmation]) {
          <button (click)="printPackagingSlip()" [disabled]="isLroRunning"
            class="btn btn-primary border btn-sm px-2 py-1" type="button">
            <i class="fas fa-receipt"></i>
            {{'SALES.ORDERS.DETAILS.BTN.ORDER-CONFIRMATION' | translate | uppercase}}
          </button>
        }
        @if (showButton[getButtons().PrintInvoice]) {
          <button (click)="printInvoice()" [disabled]="isLroRunning"
            class="btn btn-primary border btn-sm px-2 py-1" type="button"><i class="fas fa-file-invoice"></i>{{'SALES.ORDERS.DETAILS.BTN.INVOICE' | translate | uppercase}}</button>
          }
          <button class="btn dropdown-toggle btn-primary border btn-sm px-2 py-1" type="button" id="dropdownMenuButton"
            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [disabled]="isLroRunning">
            <i class="fas fa-ticket-alt"></i>
            {{'ORDER.DETAILS.BUTTON.TICKETS' | translate | uppercase}}
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" (click)="displayDownloadDialog();"
              [class.disabled]="isLroRunning || orderDetails.AllowEticketPrinting === false" href="#">
              <i class="fas fa-download me-2"></i>
              {{'ORDER.DETAILS.BUTTON.TICKETS.DOWNLOAD-ETICKET' | translate | uppercase}}
            </a>
            <a class="dropdown-item" (click)="displayEmailDialog();"
              [class.disabled]="isLroRunning || orderDetails.AllowEticketMailing === false" href="#">
              <i class="fas fa-envelope me-2"></i>
              {{'ORDER.DETAILS.BUTTON.TICKETS.SEND-ETICKET' | translate | uppercase}}
            </a>
            <a class="dropdown-item" (click)="displayPrintDialog()" [class.disabled]="isLroRunning || orderDetails.AllowSoftcard === false"
              href="#">
              <i class="fas fa-print me-2"></i>
              {{'ORDER.DETAILS.BUTTON.TICKETS.PRINT' | translate | uppercase}}
            </a>
            <a class="dropdown-item" (click)="displayHardcardDialog()"
              [class.disabled]="isLroRunning || orderDetails.AllowHardcardPrinting === false" href="#">
              <i class="fas fa-address-card me-2"></i>
              {{'ORDER.DETAILS.BUTTON.TICKETS.PRINT-HARDCARDS' | translate | uppercase}}
            </a>
          </div>
        }
        @if (orderDetails !== null && !orderDetails.Locked && orderDetails.PayByInvoice) {
          <span>
            <span class="separator"></span>
            @if (!orderDetails.IsInvoiced) {
              <button
                (click)="createInvoice()" [disabled]="isLroRunning"
                class="btn btn-warning border btn-sm px-2 py-1"
                type="button">
                <i class="fas fa-file-invoice"></i>
                {{ 'SALES.ORDERS.DETAILS.BTN.DIRECT-INVOICE' | translate | uppercase }}
              </button>
            }
            @if (orderDetails.IsInvoiced && orderDetails.Balance !== 0) {
              <button
                (click)="createCreditOrDebitInvoice()" [disabled]="isLroRunning"
                class="btn btn-warning border btn-sm px-2 py-1"
                type="button">
                <i class="fas fa-file-invoice"></i>
                {{ getInvoiceButtonText() | translate | uppercase }}
              </button>
            }
          </span>
        }
        @if ((!isReadOnly || showButton[getButtons().Edit])) {
          <span>
            <span class="separator"></span>
            @if (!isInEditMode) {
              <button (click)="toggleEditMode()" [disabled]="isLroRunning" class="btn btn-warning border btn-sm px-2 py-1" type="button">
                <i class="far fa-edit"></i>{{'GENERIC.BUTTON.EDIT' | translate | uppercase}}
              </button>
            }
            @if (isInEditMode) {
              <button (click)="toggleEditMode()" class="btn btn-secondary border btn-sm px-2 py-1" type="button">
                <i class="far fa-ban"></i>{{'GENERIC.BUTTON.CLOSE' | translate | uppercase}}
              </button>
            }
          </span>
        }
      </div>
    }
